import AccountManagement from "components/account/AccountManagement";
import SubscriptionCard from "components/account/accountSubscriptionPanel";
import { AccountSummary } from "components/account/accountSummary";
import { AddOnSection } from "components/account/Addons";
import { ConnectionSection } from "components/account/Connections";
import { PlanFeatures } from "components/account/planFeatures";
import SideMenu from "components/SideMenu";
import { useEffect, useState } from "react";

export default function AccountPage() {
  const [plan, setPlan] = useState("Founders");
  const [autoRenew, setAutoRenew] = useState(true);
  const [addons, setAddons] = useState([]);
  const [connections, setConnections] = useState([]);
  const [existingConnections, setExistingConnections] = useState([]);
  const [loading, setLoading] = useState(true);

  const toggleAddon = (addon) => {
    setAddons((prev) =>
      prev.includes(addon) ? prev.filter((a) => a !== addon) : [...prev, addon]
    );
  };

  const toggleConnections = (connection) => {
    console.log("connection", connection);
    setConnections((prev) =>
      prev.some((c) => c.name === connection.name)
        ? prev.filter((c) => c.name !== connection.name)
        : [...prev, connection]
    );
  };

  useEffect(() => {
    async function fetchExistingItems() {
      try {
        // setLoading(true);
        // const res = await fetch("/api/user/subscription"); // your endpoint
        // const data = await res.json();

        // // Assume API returns { addons: [...], connections: [...] }
        // setExistingAddons(
        //   data.addons.map((a) => ({ ...a, type: "addon", status: "included" }))
        // );
        // setExistingConnections(
        //   data.connections.map((c) => ({
        //     ...c,
        //     type: "connection",
        //     status: "included",
        //   }))
        // );

        setExistingConnections([
          {
            name: "Instagram",
            desc: "Connect Instagram account for insights",
            price: "Free",
            logo: "/logos/instagram.png",
            status: "included",
            category: "social",
          },
        ] as any);
      } catch (err) {
        console.error("Failed to fetch subscription items", err);
      } finally {
        setLoading(false);
      }
    }
    fetchExistingItems();
  }, []);

  return (
    <div className="grid min-h-screen md:grid-cols-[240px_1fr]">
      <SideMenu />
      <main className="p-6 max-w-full flex flex-col items-center justify-center w-full">
        {/* Header */}
        {/* Profile Header */}
        <AccountSummary name={"Matt"} email={"matt@apfome.com"} />
        {/* Subscription Card */}
        <SubscriptionCard
          plan={plan}
          setPlan={setPlan}
          autoRenew={autoRenew}
          setAutoRenew={setAutoRenew}
          connections={connections}
          addons={addons}
        />

        {/* What's Included */}
        <PlanFeatures plan={plan} existingConnections={existingConnections} />

        {/* Bolt-ons Section */}
        <ConnectionSection
          connections={connections}
          toggleConnection={toggleConnections}
        />
        <AddOnSection addons={addons} toggleAddon={toggleAddon} />
        <AccountManagement />
      </main>
    </div>
  );
}
